import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader";

import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch,useSelector } from "react-redux";
import { withRouter,  useHistory } from "react-router-dom";

//Actions


import {  contactsUpdate, contactsFulllist } from "../../store/contacts/actions";
import { grupotecnicoList } from "../../store/grupoTecnico/actions";




const GrupoTecnicoUpdate = (props) => {

    const dispatch = useDispatch();

    const history= useHistory();
   
    
    
    useEffect(() => {
     
     

      dispatch(grupotecnicoList())
      dispatch(contactsFulllist())
      
      
    },[dispatch]);

    
    const grupotTecnico = useSelector(state => state.GrupoTecnico.grupotecnico.results) || []
    const contact = useSelector(state => state.Contacts.contacts) || []
    const [selectedContacto, setSelelectedContacto] = useState(null)
  
   
    
    
    const  contactfilter = contact && Array.isArray(contact)?  contact.filter(item => item.id === selectedContacto ) : []
    
    console.log(contactfilter)

   
    const grupoTecnicofilter =Array.isArray(grupotTecnico)?grupotTecnico.filter(item=> item.id === contactfilter[0]?.grupo_tecnico ):[]
  
    
   

    function handleSelectContacto(selectedContacto){
        
      setSelelectedContacto(selectedContacto.value)
      
       
    }
      console.log(selectedContacto)
    
      const [formData, setFormData] = useState({
        contacto:"",
       
        grupo_tecnico: "",
      });
      
      const {
       
        grupo_tecnico,  
      } = formData;
  
    
      
      const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        }
        
        console.log(formData)
       
    const updateContact = (e) => {
        e.preventDefault();
        dispatch (contactsUpdate(contactfilter[0]?.id, {
         
          grupo_tecnico: grupo_tecnico
    
        }))
      }
      
      const redirect = () => {
        history.push("/contacts");
      };
    
      
      const redirectGoBack = () => {
        history.goBack();
        
      };
      
    return ( 
        <React.Fragment>
              <div className="page-content">
              <MetaTags>
                    <title>Grupo Tecnicos| Actualizar Contacto </title>
                    </MetaTags>
                    <Container fluid>
                         {/* Render Breadcrumb */}
          <Breadcrumb title={"Roles"} breadcrumbItem={"Actualizar Rol"} />
          {props.loading ? (
            <Loader />
          ) : (

           
            <Card className= "col-lg-8 mx-auto  mt-3">
                  {props.contactsUpdated.id ? (
                        <SweetAlert
                        title="¡Hecho!"
                        success
                        timeout={1000}
                        showConfirm={false }
                        onConfirm={() => {
                            redirect();
                        }}
                        >
                        Se ha
                        actualizado el contacto de <b>{props.contactsUpdated.first_name}</b> correctamente.
                        </SweetAlert>
                    ) : null}
                  <CardBody>
                  <h4 className="card-title">Asignar Grupo</h4>
                    <Form className="needs-validation form-control"
                     onSubmit={updateContact}
                     >
                        {/* Select Contacto */}
                <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-3">
                      <Label
                        for="contacto"
                        className="form-label"
                      >
                      Contacto
                      </Label>
                    <Select
                            menuPosition="fixed"
                            id="contacto"
                            name="contacto"
                            classNamePrefix="select2-selection"
                            placeholder ="Seleccione"
                            onChange={handleSelectContacto}
                            options ={contact && Array.isArray(contact)?  contact.map(item => ({label:item.first_name, value:item.id})) :[]}
                          />

                        
                    </Col>
                  </Row>


                  {/* Select Grupo Tecnico */}
                <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-3">
                      <Label
                        for="usuarios"
                        className="form-label"
                      >
                      Grupo De Tecnicos
                      </Label>
                      
                     
                      <select
                                id="grupo_tecnico"
                                name="grupo_tecnico"
                                className="form-select"
                                onChange={onChange}
                               
                                >
                                { grupoTecnicofilter !== [] ?  (
                                    <option value="">{grupoTecnicofilter[0]?.nombre}</option>
                                ) : (
                                    <option value="">Seleccione</option>
                                )}
                                {grupotTecnico && grupotTecnico.map(item => (
                                    <option key={item.id} value={item.id}>{item.nombre}</option>
                                ))}
                                </select>


{/*                            
                                              <MySelect
                                                  id="grupo_tecnico"
                                                  
                                                  name="grupo_tecnico"
                                                  onChange={handleSelectGrupoTecnico}
                                                  value={grupoTecnicofilter.length >0 ? grupoTecnicofilter.map(item => ({label:item.nombre, value:item.id})): selectedGrupoTecnico }   
                                                  options ={ grupotTecnico && grupotTecnico.map(item => ({label:item.nombre, value:item.id}))}
                                                  >
                                                   
                                                  
                                                  </MySelect> */}



                        
                    </Col>
                  </Row>

                {/* Buttons */}
                  <Row className="col-lg-12 justify-content-center">
                  <Col md={1} className= "mx-3">
                    <Button color="primary" type="submit" >
                      Asignar
                    </Button>
                  </Col>
                  <Col md={1} className= "mx-3">
                    
                  <button className="btn btn-primary waves-effect waves-light"
                                          onClick={redirectGoBack}
                                         >
                                            Volver
                                          </button>
                    </Col>
                    </Row>
                    </Form> 
                  </CardBody>
            </Card>
            )}
                    </Container>
              </div>
        </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
    const { error, loading,contacts, contactsUpdated } = state.Contacts;
    return { error, loading, contacts, contactsUpdated };
  };

  GrupoTecnicoUpdate.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    contactsUpdated: PropTypes.object,
  }
  
  
   
export default withRouter(connect(mapStateToProps, {contactsUpdate})(GrupoTecnicoUpdate));
